import React from "react";
import brand from "../brand";

const PrivacyPolicy = () => {
  return (
    <main className="page-shell legal-page">
      <section className="page-hero compact-hero">
        <span className="eyebrow">Privacy</span>
        <h1>Privacy Policy</h1>
        <p>
          {brand.name} is designed to display lottery result information without
          requiring personal accounts from public visitors.
        </p>
      </section>
      <section className="legal-copy">
        <p>
          We do not ask public visitors to submit personal information to view
          results. Basic technical data may be processed by hosting, analytics, or
          security systems to keep the platform fast and secure. Admin users should
          keep login credentials private and sign out on shared devices.
        </p>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
